<template>
  <div>
    <header class="header">
      <section class="container">
        <div class="d-flex justify-start align-center _py-3 _px-md-4">
          <img :src="require('@/assets/img/logo.svg')" alt="logo" />
        </div>
      </section>
    </header>
    <section class="plug">
      <div class="container">
        <div
          class="plug-container d-flex direction-column justify-center align-center _px-sm-4"
        >
          <div class="plug-container__img" @click="count">
            <svg
              width="328"
              height="225"
              viewBox="0 0 328 225"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M108.23 93.3497L93.5039 90.471C89.8939 96.2245 87.0569 102.287 85.0023 108.527L96.642 118.015C95.9281 120.912 95.4041 123.835 95.078 126.774L80.8994 131.633C80.6705 138.308 81.2434 144.989 82.5934 151.523L97.3955 153.918C98.22 156.765 99.2166 159.558 100.403 162.29L90.5541 173.587C93.6444 179.412 97.4577 184.912 101.976 189.963L115.987 184.637C117.56 186.146 119.215 187.596 120.956 188.977C121.56 189.452 122.179 189.899 122.787 190.355L119.905 205.079C125.662 208.691 131.724 211.528 137.958 213.584L147.455 201.94C150.345 202.654 153.271 203.175 156.208 203.505L161.067 217.683C167.746 217.915 174.427 217.348 180.957 215.989L183.347 201.178C186.189 200.361 188.989 199.363 191.721 198.177L203.018 208.026C208.837 204.943 214.336 201.123 219.393 196.597L214.063 182.59C215.575 181.014 217.026 179.364 218.404 177.621C218.882 177.02 219.327 176.404 219.782 175.79L234.506 178.678C238.109 172.92 240.953 166.863 243.008 160.622L231.368 151.135C232.079 148.241 232.603 145.318 232.93 142.379L247.111 137.516C247.345 130.834 246.776 124.156 245.416 117.62L230.614 115.225C229.792 112.375 228.795 109.581 227.609 106.85L237.458 95.5523C234.369 89.7342 230.555 84.2343 226.036 79.1825L212.026 84.5093C210.451 83.0035 208.797 81.5437 207.05 80.1634C206.448 79.685 205.833 79.2402 205.223 78.7946L208.111 64.0637C202.351 60.4547 196.295 57.6167 190.057 55.5586L180.563 67.1992C177.665 66.4951 174.741 65.9649 171.808 65.6378L166.943 51.4601C160.267 51.2312 153.589 51.8006 147.052 53.1541L144.657 67.9563C141.814 68.7834 139.017 69.7774 136.285 70.9639L124.992 61.1175C119.17 64.2043 113.671 68.0238 108.619 72.5425L113.942 86.5504C112.437 88.1258 110.979 89.7762 109.599 91.5228C109.127 92.1235 108.682 92.7392 108.23 93.3497ZM137.112 113.295C148.869 98.4339 170.44 95.9186 185.297 107.673C200.154 119.428 202.666 141.002 190.911 155.853C179.156 170.71 157.582 173.223 142.731 161.467C127.874 149.712 125.362 128.145 137.112 113.295Z"
                fill="#77BB2F"
              />
              <path
                d="M279.293 7.88122L275.487 -4.77113e-05C271.538 0.327055 267.716 1.12291 264.085 2.3463L263.727 11.0981C262.125 11.7781 260.577 12.5559 259.091 13.4316L251.864 8.51224C248.667 10.7401 245.749 13.344 243.171 16.2596L247.23 24.0069C246.19 25.3874 245.234 26.8298 244.374 28.339L235.655 27.6926C234.017 31.1722 232.784 34.8759 232.006 38.7521L239.393 43.4294C239.238 44.6914 239.14 45.9715 239.104 47.267C239.094 47.7151 239.102 48.1607 239.102 48.6037L231.22 52.4078C231.547 56.3588 232.343 60.1809 233.564 63.8099L242.321 64.1705C242.998 65.77 243.779 67.3179 244.652 68.804L239.733 76.0311C241.96 79.2299 244.562 82.1506 247.48 84.7236L255.23 80.6594C256.605 81.6999 258.05 82.658 259.559 83.5183L258.913 92.2366C262.387 93.8747 266.094 95.1058 269.975 95.8836L274.65 88.4969C275.914 88.6514 277.192 88.7518 278.487 88.7853C278.935 88.7982 279.378 88.7905 279.824 88.7879L283.626 96.6718C287.574 96.3395 291.396 95.5488 295.028 94.3254L295.386 85.5736C296.985 84.8936 298.533 84.1158 300.019 83.2401L307.249 88.1595C310.45 85.9316 313.368 83.3302 315.944 80.4095L311.885 72.6622C312.928 71.2817 313.883 69.8394 314.744 68.3301L323.462 68.9765C325.098 65.4995 326.331 61.7958 327.109 57.9196L319.722 53.2423C319.874 51.9803 319.977 50.6977 320.011 49.3996C320.024 48.9514 320.016 48.5084 320.011 48.068L327.897 44.2639C327.568 40.3129 326.774 36.4933 325.553 32.8618L316.799 32.5012C316.114 30.9017 315.339 29.3512 314.466 27.8677L319.382 20.6381C317.154 17.4418 314.553 14.5236 311.635 11.9455L303.888 16.0046C302.507 14.9666 301.065 14.0085 299.556 13.1483L300.202 4.43251C296.725 2.79445 293.019 1.56333 289.142 0.785505L284.465 8.16968C283.203 8.01773 281.923 7.91471 280.625 7.88122C280.179 7.87092 279.736 7.87864 279.293 7.88122ZM280.084 28.339C291.133 28.6301 299.852 37.8198 299.561 48.8664C299.27 59.9131 290.077 68.6314 279.033 68.3378C267.987 68.0468 259.268 58.8545 259.562 47.8104C259.853 36.7638 269.043 28.048 280.084 28.339Z"
                fill="#EBF6E3"
              />
              <path
                d="M5.56503 89.684L0.102788 92.3221C0.329488 95.0585 0.881063 97.7073 1.72896 100.224L7.79455 100.472C8.26581 101.582 8.80489 102.655 9.41181 103.685L6.00237 108.694C7.54644 110.909 9.35111 112.931 11.3718 114.718L16.7412 111.905C17.698 112.626 18.6976 113.288 19.7437 113.884L19.2956 119.926C21.7072 121.062 24.2741 121.917 26.9606 122.456L30.2023 117.336C31.0769 117.444 31.9641 117.511 32.862 117.536C33.1726 117.544 33.4814 117.538 33.7884 117.538L36.4249 123C39.1632 122.773 41.8122 122.222 44.3274 121.376L44.5773 115.307C45.6858 114.838 46.7586 114.297 47.7886 113.692L52.7974 117.101C55.0144 115.557 57.0387 113.754 58.8219 111.732L56.0051 106.361C56.7263 105.408 57.3903 104.406 57.9865 103.36L64.0289 103.808C65.1642 101.4 66.0175 98.8319 66.5566 96.1419L61.437 92.9022C61.5441 92.0258 61.6138 91.1405 61.637 90.2427C61.6459 89.9321 61.6405 89.6251 61.6387 89.3163L67.1028 86.6817C66.8725 83.9453 66.3245 81.2965 65.4766 78.7797L59.411 78.5316C58.9398 77.4231 58.4007 76.3504 57.7938 75.3205L61.2032 70.3101C59.6591 68.0914 57.8562 66.069 55.832 64.2841L50.4626 67.0972C49.5058 66.3743 48.5061 65.712 47.4601 65.1159L47.9082 59.0738C45.4983 57.9404 42.9314 57.0854 40.2449 56.5463L37.0033 61.6656C36.1286 61.5602 35.2397 61.4888 34.34 61.4656C34.0294 61.4567 33.7224 61.4621 33.4171 61.4656L30.7806 56.0001C28.0424 56.2286 25.3951 56.7784 22.8782 57.6244L22.6283 63.6915C21.5198 64.1663 20.4452 64.7036 19.417 65.3087L14.4064 61.9012C12.1911 63.4452 10.1687 65.248 8.38183 67.2703L11.1951 72.6395C10.4757 73.5962 9.81166 74.5958 9.21545 75.6417L3.17485 75.1937C2.03955 77.6034 1.18631 80.172 0.647221 82.8583L5.76495 86.0998C5.65963 86.9744 5.58823 87.8615 5.56503 88.7612C5.55789 89.0699 5.56324 89.377 5.56503 89.684ZM19.7437 89.136C19.9454 81.4785 26.3144 75.4365 33.9705 75.6382C41.6266 75.8399 47.669 82.2104 47.4655 89.8643C47.2638 97.5199 40.8929 103.562 33.2386 103.358C25.5826 103.157 19.542 96.7881 19.7437 89.136Z"
                fill="#EBF6E3"
              />
            </svg>
          </div>
          <div
            class="plug-container__title _mt-13 _fs-48 _lh-54 _mt-md-8 _fs-md-32 _lh-md-38 _fw-700"
          >
            На сайте Herbalife Academy идут технические работы
          </div>
          <div
            class="plug-container__descr _mt-8 _fs-30 _lh-42 _mt-md-5 _fs-md-24 _lh-md-32 _fs-sm-20 _lh-sm-26 _fw-400"
          >
            На сайте Herbalife Academy идут технические работы: прямо сейчас мы
            делаем его ещё удобнее для вас и наполняем полезным контентом.
          </div>
        </div>
      </div>
    </section>
    <footer class="footer">
      <div class="container _pt-15 _pb-12 _px-md-4">
        <p class="footer__copy _mb-4 _fs-16 _lh-24">
          © 2020 Herbalife International of America, Inc. | ООО Гербалайф
          Интернэшнл РС.
        </p>

        <div class="_mb-4">
          <a href="/policy" target="_blank" class="footer_policy _fs-16 _lh-24">
            Политика конфиденциальности
          </a>
        </div>

        <p class="footer__secondary _fs-16 _lh-24">
          Воспроизведение материалов данного сайта возможно только при наличии
          письменного разрешения. Все права защищены. Все торговые марки и
          изображения продуктов на данном сайте, если не указано иное, являются
          собственностью Herbalife International, Inc.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Plug",
  data: () => ({
    counter: 0,
  }),
  methods: {
    count() {
      this.counter++;
      if (this.counter === 5) {
        this.setCookie("access", "true", 365);
        document.location.reload();
      }
    },
    setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
  },
};
</script>

<style lang="scss" scoped>
.plug {
  height: calc(100vh - 56px - 237px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media screen and (max-width: 1220px) {
    min-height: calc(100vh - 56px - 261px);
    height: auto;
  }
  @media screen and (max-width: 743px) {
    min-height: calc(100vh - 56px - 381px);
    height: auto;
  }
  &-container {
    max-width: 785px;
    margin: 0 auto;
    @media screen and (max-width: 1220px) {
      max-width: 672px;
    }
    &__img svg {
      @media screen and (max-width: 1220px) {
        height: 164px;
        width: 239px;
      }
      @media screen and (max-width: 743px) {
        height: 110px;
        width: 161px;
      }
    }
    &__title {
      text-align: center;
    }
    &__descr {
      text-align: center;
    }
  }
}

.footer {
  border-top: 1px solid color(grey-second);
  background-color: color(light);

  &__copy {
    font-family: "Noto-Sans", sans-serif;
    color: color(dark-blue);
  }

  &_policy {
    font-family: "Noto-Sans", sans-serif;
    color: color(dark-blue);
    text-decoration: underline;
    transition: all 0.3s ease;

    &:hover {
      color: lighten(color(dark-blue), 10);
    }
  }

  &__secondary {
    font-family: "Noto-Sans", sans-serif;
    color: color(grey);
  }
}
</style>
